/**
 * Oddělení firmy = role v administraci (D-103). Pořadí je pořadí priority:
 * podle něj se určuje hlavní oddělení uživatele (úvodní přehled, pořadí menu).
 */
export const DEPARTMENTS = ['admin', 'customer_care', 'mailing', 'obchod', 'marketing'];
export const DEPARTMENT_LABEL = {
    admin: 'Administrátor',
    customer_care: 'Customer care',
    mailing: 'Mailing specialista',
    obchod: 'Obchodní oddělení',
    marketing: 'Marketing',
};
/** Staré kódy rolí → oddělení. Používá se na vstupu API a v migraci; ukládají se jen nové kódy. */
export const LEGACY_ROLE_ALIASES = {
    pece: 'customer_care',
    emailing: 'mailing',
    provoz: 'obchod',
    vedeni: 'marketing',
};
/** Oddělení → starý kód do nepoužívaného sloupce `users.role` (do úkolu 2, kdy se sloupec uvolní). */
export const LEGACY_ROLE_OF = {
    admin: 'admin',
    customer_care: 'pece',
    mailing: 'emailing',
    obchod: 'provoz',
    marketing: 'vedeni',
};
export function normalizeDepartment(code) {
    const c = code.trim().toLowerCase();
    if (DEPARTMENTS.includes(c))
        return c;
    return LEGACY_ROLE_ALIASES[c] ?? null;
}
/** Seznam kódů (nových i starých) → seznam oddělení bez duplicit; `null` při neznámém kódu nebo prázdném seznamu. */
export function normalizeDepartments(codes) {
    const out = [];
    for (const code of codes) {
        const d = normalizeDepartment(code);
        if (!d)
            return null;
        if (!out.includes(d))
            out.push(d);
    }
    return out.length > 0 ? out : null;
}
/** Hlavní oddělení = první v pořadí priority. */
export function primaryDepartment(list) {
    return DEPARTMENTS.find((d) => list.includes(d)) ?? list[0] ?? 'marketing';
}
//# sourceMappingURL=departments.js.map